import { useState } from "react";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Arsenal } from "@/components/site/Arsenal";
import { Bento } from "@/components/site/Bento";
import { Ecosystem } from "@/components/site/Ecosystem";
import { Manifesto } from "@/components/site/Manifesto";
import { Gallery } from "@/components/site/Gallery";
import { Contact } from "@/components/site/Contact";
import { Partner } from "@/components/site/Partner";
import { QuoteDialog } from "@/components/site/QuoteDialog";

export default function Home() {
  const [quote, setQuote] = useState(null);
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Arsenal onQuote={setQuote} />
      <Bento />
      <Manifesto />
      <Ecosystem onQuote={setQuote} />
      <Gallery />
      <Partner />
      <Contact />
      <QuoteDialog product={quote} onClose={() => setQuote(null)} />
    </main>
  );
}
